// AntiSlavery.jsx
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { TranslationNamespace } from '../resource/translationNamespace.js';
import { LegalPageLayout } from '../component/LegalPageLayout.jsx';
import { NULL_FUNCTION } from '../resource/defaults.js';

const AntiSlavery = ({
  t,
  goBack = NULL_FUNCTION,
  handleMailTo = NULL_FUNCTION,
}) => (
  <LegalPageLayout
    title={t('anti_slavery_title', { ns: TranslationNamespace.SETTINGS })}
    htmlString={t('anti_slavery_seo_description', {
      ns: TranslationNamespace.SETTINGS,
      interpolation: { prefix: '#__NONE__#', suffix: '#__NONE__#' },
    })}
    goBack={goBack}
    onMailTo={handleMailTo}
  />
);

AntiSlavery.propTypes = {
  t: PropTypes.func,
  goBack: PropTypes.func,
  handleMailTo: PropTypes.func,
};

export { AntiSlavery };
export default withTranslation()(memo(AntiSlavery));
